import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import VueAxios from 'vue-axios'
import store from './store'
import VueTheMask from 'vue-the-mask'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import './assets/sass/main.scss'
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.config.devtools = true
Vue.config.productionTip = false
Vue.use(VueAxios, axios,)
Vue.use(VeeValidate);
Vue.use(VueMeta)
Vue.use(BootstrapVue);
Vue.use(VueTheMask);
new Vue({
 store,
 router,
  render: h => h(App),
}).$mount('#app')
